/* null7x Portfolio Configuration */

// Website related settings
const settings = {
  isSplash: true,
};

// SEO Related settings
const seo = {
  title: "null7x Portfolio",
  description:
    "CEO of Arion AI. Passionate Web & Android Developer building innovative mobile and web applications.",
  og: {
    title: "null7x Portfolio",
    type: "website",
    url: "https://null7x.github.io/",
  },
};

// Home Page
const greeting = {
  title: "Azizov Aminjon",
  logo_name: "null7x",
  nickname: "null7x",
  subTitle:
    "CEO of Arion AI. Passionate Web & Android Developer building innovative mobile and web applications that make a difference.",
  resumeLink: "https://t.me/Null7_x",
  portfolio_repository: "https://github.com/null7x/null7x-portfolio",
  githubProfile: "https://github.com/null7x",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/null7x",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/@null7.x",
    fontAwesomeIcon: "fa-youtube",
    backgroundColor: "#FF0000",
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/null7.x",
    fontAwesomeIcon: "fa-instagram",
    backgroundColor: "#E4405F",
  },
  {
    name: "Telegram",
    link: "https://t.me/+Dg-pmQ_vd8djMGVi",
    fontAwesomeIcon: "fa-telegram",
    backgroundColor: "#27A0D9",
  },
];

const skills = {
  data: [
    {
      title: "Mobile Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Building cross-platform apps with Flutter & Dart",
        "⚡ Native Android development with Kotlin",
        "⚡ Integrating Firebase and cloud services",
      ],
      softwareSkills: [
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: { color: "#02569B" },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: { color: "#0175C2" },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: { color: "#3DDC84" },
        },
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "simple-icons:kotlin",
          style: { color: "#7F52FF" },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: { color: "#FFCA28" },
        },
      ],
    },
    {
      title: "Web Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive web applications with React & Next.js",
        "⚡ Creating RESTful APIs with Node.js",
        "⚡ Developing beautiful UI with modern CSS",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: { color: "#E34F26" },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: { color: "#1572B6" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: { backgroundColor: "#000000", color: "#F7DF1E" },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: { color: "#339933" },
        },
      ],
    },
    {
      title: "AI & Tools",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Working with AI models and Python",
        "⚡ Version control with Git and GitHub",
        "⚡ UI/UX design with Figma",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: { color: "#F05032" },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: { color: "#181717" },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#1488C6" },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: { color: "#F24E1E" },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [],
};

const certifications = {
  certifications: [],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work & Projects",
  description:
    "I am the CEO of Arion AI, building innovative mobile and web applications. I have experience in full-stack web development and native Android development.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "CEO & Founder",
          company: "Arion AI",
          company_url: "https://github.com/null7x/arion_ai",
          logo_path: "arion.png",
          duration: "2024 - Present",
          location: "Remote",
          description:
            "Leading the development of innovative AI-powered mobile and web applications. Building Quran apps, AI bots, and other products that help people.",
          color: "#7F52FF",
        },
      ],
    },
  ],
};

// Open Source
const openSource = {
  showGithubProfile: "true",
  githubUserName: "null7x",
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects use modern technologies like Flutter, Dart, Python, React, and more. I focus on creating useful applications.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Open Source",
  description: "My open source projects on GitHub.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "arion-ai",
      name: "Arion AI",
      description: "🤖 AI-powered mobile application built with Flutter",
      url: "https://github.com/null7x/arion_ai",
      language: "Dart",
    },
    {
      id: "quran-arion",
      name: "Quran Arion",
      description: "📖 Beautiful Quran application with modern UI",
      url: "https://github.com/null7x/Quran-Arion",
      language: "Dart",
    },
    {
      id: "quran-mp3",
      name: "Quran MP3",
      description: "🎧 Quran audio player app with recitations",
      url: "https://github.com/null7x/quran-mp3",
      language: "Dart",
    },
    {
      id: "arion-bot",
      name: "Arion Bot",
      description: "🤖 AI Bot project ⭐2",
      url: "https://github.com/null7x/Arion-bot-",
      language: "Dart",
    },
    {
      id: "sdxl-model-merger",
      name: "SDXL Model Merger",
      description: "🔧 Python tool for merging Stable Diffusion XL models ⭐1",
      url: "https://github.com/null7x/sdxl-model-merger",
      language: "Python",
    },
    {
      id: "portfolio",
      name: "Portfolio",
      description: "🌐 My personal portfolio website ⭐2",
      url: "https://github.com/null7x/portfolio",
      language: "JavaScript",
    },
  ],
};

// Contact Info
const contactInfo = {
  title: "Contact Me",
  subtitle: "Let's connect and build something amazing together!",
  number: "",
  email_address: "adamwtjk@gmail.com",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "my_photo.png",
    description:
      "You can reach me on Instagram, Telegram, YouTube and GitHub. I'm always open for collaboration and new ideas!",
  },
  blogSection: {
    title: "GitHub",
    subtitle: "Check out my open source projects and contributions.",
    link: "https://github.com/null7x",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Location",
    subtitle: "Available for remote work worldwide",
    locality: "",
    country: "",
    region: "",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactInfo,
  contactPageData,
  openSource,
};
